import { tryCatch } from '@/lib/try-catch'
import { vanillaApiClient } from '@/trpc/vanilla'
import { encrypt } from '@/utils'

import {
  deleteUserContextPayloadById,
  getUserContextPayload,
} from '../../local-db/user-context'

const onError = async ({
  error,
  id,
  message,
}: {
  error: Error
  id: number
  message: string
}) => {
  console.error(message, error)
  return await deleteUserContextPayloadById(id)
}

export const generateAndSaveContext = async () => {
  const payloads = await getUserContextPayload()
  for (const payload of payloads) {
    const { data: generatedContext, error: generateError } = await tryCatch(
      vanillaApiClient.ai.generateUserContext.query({
        userContext: payload.prevContext,
        userInput: payload.userInput,
      }),
    )

    if (generateError) {
      return onError({
        id: payload.id,
        error: generateError,
        message: 'Error generating context',
      })
    }

    const encryptedContext = await encrypt(generatedContext, payload.encryptKey)

    const { error: updateError } = await tryCatch(
      vanillaApiClient.userSettings.update.mutate({
        generalInformation: encryptedContext,
      }),
    )

    if (updateError) {
      return onError({
        id: payload.id,
        error: updateError,
        message: 'Error updating context',
      })
    }

    return await deleteUserContextPayloadById(payload.id)
  }
}
